import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M29 5a1 1 0 0 1-1 1H7a1 1 0 0 1 0-2h21a1 1 0 0 1 1 1m-6 4a1 1 0 0 0-1-1H4a1 1 0 0 0 0 2h18a1 1 0 0 0 1-1m-2 4a1 1 0 0 0-1-1H7a1 1 0 0 0 0 2h13a1 1 0 0 0 1-1m2 4a1 1 0 0 0-1-1H11a1 1 0 0 0 0 2h11a1 1 0 0 0 1-1m0 3h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2m-3 4h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-4 4h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2"
    />
  </svg>
);
const SvgIconWeatherTornado = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconWeatherTornado);
export default Memo;
